<template>
  <div class="dashboard-widget">
    <report-widget v-if="widgetType === 'report' || widgetType === 'chart' || widgetType === 'list'"
    :widgetData="widgetData"
    :widgetInfo="widgetInfo"
    :chartDateFiltersPrimary="chartDateFiltersPrimary"
    :productFilters="productFilters"
    :widgetType="widgetType">
    </report-widget>

    <block-widget v-if="widgetType === 'block'"
    :widgetData="widgetData"
    :widgetInfo="widgetInfo"
    :widgetType="widgetType">
    </block-widget>
  </div>
</template>

<script>
import ReportWidget from './ReportWidget';
import BlockWidget from './BlockWidget';

export default {
  props: ['fieldData', 'widgetType', 'widgetData', 'widgetInfo', 'chartDateFiltersPrimary', 'productFilters'],
  components: {
    ReportWidget,
    BlockWidget,
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/presentational/widgets/DashboardWidget.vue?4ec81af5